module.exports = __webpack_public_path__ + "static/img/eightLast.2674ae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eightLast.png
// module id = 339d
// module chunks = 1